import { useCallback, useEffect, useState } from "react";

import {
  Carousel,
  CarouselApi,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "src/v1/ui/carousel/carousel";

const carouselDetails = [
  {
    title: "12만원 소액사건 완벽해결",
    description: "채권액: 120,000 원",
    name: "나** 님",
    startDate: "2026.02.09",
    endDate: "2026.06.01",
    image: "na",
  },
  {
    title: "다른 곳에서 실패한 돈 회수",
    description: "채권액: 14,000,000 원",
    name: "주** 님",
    startDate: "2026.04.27",
    endDate: "2026.05.27",
    image: "joo",
  },
  {
    title: "지인에게 빌려준 돈 회수",
    description: "채권액: 4,300,000 원",
    name: "홍** 님",
    startDate: "2026.03.16",
    endDate: "2026.05.26",
    image: "hong2",
  },
  {
    title: "3달만에 위자료 회수 성공",
    description: "채권액: 11,687,817 원",
    name: "김** 님",
    startDate: "2026.02.19",
    endDate: "2026.05.26",
    image: "kim2",
  },
  {
    title: "막막했던 중고사기 소액 해결",
    description: "채권액: 250,000 원",
    name: "이** 님",
    startDate: "2025.11.27",
    endDate: "2026.05.21",
    image: "lee",
  },
  {
    title: "2년동안 못받은 돈 5일만에 해결",
    description: "채권액: 5,693,868 원",
    name: "손** 님",
    startDate: "2025.02.20",
    endDate: "2025.02.25",
    image: "son",
  },
  {
    title: "계약금 문제가 해결됐어요",
    description: "채권액: 1,000,000 원",
    name: "김** 님",
    startDate: "2025.01.19",
    endDate: "2025.01.27",
    image: "kim",
  },
  {
    title: "회수가 정말 빨랐어요",
    description: "채권액: 1,000,000 원",
    name: "정** 님",
    startDate: "2025.01.07",
    endDate: "2025.02.11",
    image: "jung",
  },
  {
    title: "스트레스가 해소되었어요",
    description: "채권액: 2,540,000 원",
    name: "박** 님",
    startDate: "2024.06.11",
    endDate: "2024.07.15",
    image: "park",
  },
  {
    title: "정말 이 가격에 되네요",
    description: "채권액: 5,000,000 원",
    name: "안** 님",
    startDate: "2024.05.23",
    endDate: "2024.11.21",
    image: "ann",
  },
  {
    title: "혼자서는 막막했어요",
    description: "채권액: 4,326,304 원",
    name: "홍** 님",
    startDate: "2025.02.11",
    endDate: "2025.03.26",
    image: "hong",
  },
];

export function ReviewCarousel() {
  const [currentSlideIndex, setCurrentSlideIndex] = useState(0);
  const [api, setApi] = useState<CarouselApi | null>(null);
  const logSlidesChanged = useCallback((api: CarouselApi) => {
    setCurrentSlideIndex(api?.slidesInView()[0] || 0);
  }, []);
  useEffect(() => {
    if (api) {
      api.on("slidesInView", logSlidesChanged);
    }
  }, [api, logSlidesChanged]);
  return (
    // max-w-full: 슬라이드들 때문에 캐러셀이 화면보다 넓어지는 것을 막는다.
    // (넓어지면 모바일에 가로 스크롤이 생기고, 하단 고정 바가 화면 아래로 밀려 잘려 보인다)
    <div className="relative flex flex-col gap-[16px] max-w-full desktop:w-[1140px]">
      {/* Carousel Content */}
      <Carousel
        setApi={setApi}
        className="bg-[#E0E0EE]   pt-[19px] tablet:rounded-3xl"
      >
        <CarouselContent>
          {carouselDetails.map((detail) => (
            <CarouselItem key={detail.image} className="w-full">
              <div className="flex flex-row justify-center items-center gap-[24px] w-full">
                <img
                  src={`https://vws-front-store.s3.ap-northeast-2.amazonaws.com/landing/reviews/kakao-talks/${detail.image}.webp`}
                  loading="lazy"
                  decoding="async"
                  className="px-[12px] tablet:w-[328px]"
                  alt={detail.name}
                />
                <div className="hidden desktop:flex flex-col gap-[8px]">
                  <div className="px-[13px] border-solid border-[#5E87FF] border-[1px] rounded-[24px] w-fit text-[#5E87FF] text-body-3">
                    {detail.name}
                  </div>
                  <div>
                    <div className="text-body-1">{detail.title}</div>
                    <div className="text-display-2 text-[#4f4f4f]">
                      {detail.description}
                    </div>
                  </div>
                  <div className="flex justify-between text-[#9e9e9e]">
                    <div className="text-body-3">수임일:{detail.startDate}</div>
                    <div className="text-body-3">회수일:{detail.endDate}</div>
                  </div>
                </div>
              </div>
            </CarouselItem>
          ))}
        </CarouselContent>
        <CarouselPrevious className="left-[12px] tablet:left-[30px] desktop:left-[115px]" />
        <CarouselNext className="right-[12px] tablet:right-[30px] desktop:right-[115px]" />
      </Carousel>
      {currentSlideIndex !== undefined && (
        <div className="text-center  bg-white desktop:hidden">
          <div className="text-body-2">
            {carouselDetails[currentSlideIndex].title}
          </div>
          <div className="text-display-2 text-[#4f4f4f]">
            {carouselDetails[currentSlideIndex].description}
          </div>
        </div>
      )}
    </div>
  );
}
